module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot22.b47fd3a7.jpg";